import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./Detail'))
const ReviewDetail = lazy(() => import('./ReviewDetail'))

//	///////////////////////
//	MARK: EXPORTS
/**
 * ★ Gestion du changement et revues de sécurité.
 *
 * <p>Les revues n'ont pas de menu item : `MenuItem.label` est unique en base, et un doublon fait
 * échouer `ensureMenuItem` en emportant en silence tous les seeds qui suivent. Elles vivent donc
 * sous `role--safety--changes`.
 *
 * <p>Préfixes statiques pour les fiches — un segment statique bat toujours `:param` (`01` §15.2).
 */
export const SafetyChangeRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--safety--changes']}>
    <Route path='change/:changeId/*' element={<Detail />} />
    <Route path='reviews/:reviewId' element={<ReviewDetail />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
